module.exports = "https://www.gc-pro.gnp.com.mx/d8b4e0b6d22a3b42b73589cf02fe8f74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Icono_SmartTrip_PSC_1a.svg
// module id = 8054
// module chunks = 0